import React from 'react';

const Scanner = () => {
  return (
   <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.72429 0.862976H6.77054C3.50791 0.862976 0.863037 3.50785 0.863037 6.77048V9.72423M15.6318 0.862976H18.5855C21.8482 0.862976 24.493 3.50785 24.493 6.77048V9.72423M24.493 15.6317V18.5855C24.493 21.8481 21.8482 24.493 18.5855 24.493H15.6318M9.72429 24.493H6.77054C3.50791 24.493 0.863037 21.8481 0.863037 18.5855V15.6317" stroke="#595A5B" stroke-width="1.72595" stroke-linecap="round"/>
<path d="M5.86304 12.863H20.286" stroke="#595A5B" stroke-width="1.72595" stroke-linecap="round"/>
</svg>
  );
};

export default Scanner;

